import { Container, Typography, Box, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Typography variant="h2" component="h1" gutterBottom align="center">
          Contact Me
        </Typography>
        <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Phone
            </Typography>
            <Typography variant="body1" color="text.secondary">
              7601050990
            </Typography>
          </Box>
          <Box>
            <Typography variant="h6" gutterBottom>
              Email
            </Typography>
            <Typography variant="body1" color="text.secondary">
              kaditya50@gmail.com
            </Typography>
          </Box>
        </Paper>
      </Container>
    </motion.div>
  );
};

export default Contact;
